// Material Kit 2 PRO React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/footer-logo.png";

const date = new Date().getFullYear();

export default {
  brand: {
    image: logoCT,
    route: "/",
  },
  menus: [
    {
      name: "Services",
      items: [
        { name: "Find a House", href: "/house" },
        { name: "Find a Car", href: "/car" },
        { name: "Find a Land", href: "/land" },
      ],
    },
    {
      name: "Other Services",
      items: [
        { name: "Find a Maid", href: "/maid" },
        { name: "Find a Nanny", href: "/nanny" },
        { name: "Find a Driver", href: "/drivers" },
      ],
    },
    {
      name: "resources",
      items: [
        { name: "Booking", href: "/services/booking" },
        { name: "Contact us", href: "/contact" },
        { name: "Career", href: "/employee" },
      ],
    },
    {
      name: "legal",
      items: [
        { name: "Terms & Conditions", href: "/terms-condtions" },
        { name: "Privacy Policy", href: "/privacy-policy" },
        { name: "Disclaimer", href: "/disclaimer" },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular" sx={{ color: "#8898aa" }}>
      &copy; {date} Helper Everywhere | All rights reserved.
    </MKTypography>
  ),
};
